import { Injectable } from '@angular/core';

import { AtlasenseapiService } from '../api.service';
import { ConfigurationService } from '../config.service';

import { Role } from './role';

const ROLE_ENDPOINT = 'role';

@Injectable()
export class RoleService {

  constructor(
    public api: AtlasenseapiService,
    public config: ConfigurationService) {}

  getRoles(): Role[]{
    // Mock roles
    let roles: Role[] = [
      {
        name: "owner"
      },
      {
        name: "collaborator"
      },
      {
        name: "reader"
      }
    ]
    return roles;
  }

}
